/**
 * Element names for the create/edit Sales catalogue form.
 */
export enum CatalogueFormField {
  // Step 1
  // Sales information
  SaleType = 'saleType',
  Title = 'title',
  FlockName = 'flock',
  // Sale & listing dates
  SaleStartDate = 'saleStartDate',
  SaleEndDate = 'saleEndDate',
  ListingStartDate = 'listingStartDate',
  ListingEndDate = 'listingEndDate',
  // Location
  PropertyName = 'propertyName',
  Address = 'address',
  Town = 'city',
  Postcode = 'postcode',
  State = 'state',
  Country = 'country',
  // Contact details
  ContactName = 'contactName',
  Email = 'contactEmail',
  Phone = 'contactPhoneNumber',
  // Step 2
  RamSelect = 'onRamSelect',
  Website = 'contactUrl',
  AuctionWebsite = 'auctionUrl',
  SaleDescription = 'description',
  Logo = 'catalogueImages',
  // Step 3
  AnimalFile = 'animalFile',
  AnimalPrice = 'animalPrice',
  Animals = 'animals',
  Doses = 'doses'
}
